import Loader from "react-loader-spinner";
import { faPenSquare, faPlus, faPlusSquare, faTags, faUserEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, FormGroup, OverlayTrigger, Popover, Row, Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import moment from "moment-jalali";
import StatusBadge from "../Components/Shared/StatusBadge";
import { Calendar2CheckFill, Calendar2DateFill, CheckLg, CloudUploadFill, Download, Link45deg, List, PersonCheckFill, PersonPlusFill, Toggles2, Trash } from "react-bootstrap-icons";
import SeverityBadge from "../Components/Shared/SeverityBadge";
import PriorityBadge from "../Components/Shared/PriorityBadge";
import { create, get, getNextNumber, getProjectsForSelect, update } from "../store/api/workItemsApi";
import { useDispatch } from "react-redux";
import {
    attachFile,
    convertFromMoment,
    convertToMoment,
    deleteAttachment,
    downloadFile,
    getAttachmentList,
    setErrorDialog,
    useIsMobileApp,
    workItemRelationType,
    workItemSeverity,
    workItemTypes
} from "../../store/api/CommonFunctions";

import Checklist from "../../Components/CheckList/Checklist";
import { getWorkItemsBaseInfoes } from "../store/api/workItemsApi";
import ModalReferDocument from "../../Components/Modals/ModalReferDocument";
import DatePicker from "react-datepicker2";
import WorkItemRelations from "../Components/WorkItemRelations";
import WorkItemControl from "../Components/WorkItemControl";
import ActivityList from "../Components/WorkItemActivities/ActivityList";
import ModalLabels from "../Components/WorkItemLabels/ModalLabels";
import LabelList from "../Components/WorkItemLabels/LabelList";
import PopWorkItemStatus from "../Components/PopWorkItemStatus";
import ProgressBar from "../../Components/ProgressBarNew";
import { changeDoneStatus, setDoneComment } from "../store/api/workItemCheckListApi";
import WorkItemLinks from "../Components/WorkItemLinks/WorkItemLinks";
import ModalWorkItemLinks from "../Components/WorkItemLinks/ModalWorkItemLinks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import WorkItemRefer from "../Components/WorkItemRefers/WorkItemRefer";
import { monitorRemoveMonitorWorkItem } from "../store/api/FlowAPI";
import SearchableSelect from "../../Components/SearchableSelect";
import ModalAddEditChequeFunctions from "../../Accounting/Components/ModalAddEditChequeFunctions";
import { getCustomerIDFromEventID, getCustomerIDFromTicketID } from "../../CRM/store/api/CustomerApi";

export default function CreateEditWorkItem() {
    //#region Constants
    const history = useHistory();
    const { id, isProject } = useParams();
    const isProjectBool = JSON.parse(isProject ?? "false");
    const isMobile = useIsMobileApp();
    const title = isProjectBool ? "پروژه" : "وظیفه";
    const dispatch = useDispatch();
    const inputAttach = useRef();
    const [baseInfoes, setBaseInfoes] = useState(null);
    const [pendingGet, setPendingGet] = useState(false);
    const [popStatusData, setPopStatusData] = useState(null);
    const [pendingSubmit, setPendingSubmit] = useState(false);
    const [popReferDoc, setReferDocPop] = useState({ show: false });
    const [showModalLabels, setShowModalLabels] = useState(false);
    const [progressPercent, setProgressPercent] = useState(0);
    const [attachList, setAttachList] = useState(null);
    const [modalCheqFunctions, setModalCheqFunctions] = useState({ Show: false });

    const [workItemData, setWorkItemData] = useState({
        CreationDate: moment().local("en").format("YYYY-MM-DD"),
        PCreationDate: moment().local("fa").format("jYYYY/jMM/jDD"),
        Type: workItemTypes.task,

    });
    const { register, errors, handleSubmit, control, reset } = useForm({
    });

    //#endregion

    //#endregion functions

    async function handleSubmitWorkItem(data) {
        if (pendingSubmit) {
            return;
        }
        /********************************* data *************************/
        data.StartDate = convertFromMoment(data.StartDate).date;
        data.AlarmDate = convertFromMoment(data.AlarmDate).date;
        data.DueDate = convertFromMoment(data.DueDate).date;
        data.CompletedDate = convertFromMoment(data.CompletedDate).date;
        data.Links = workItemData.Links;
        data.Labels = workItemData.Labels;
        data.Activities = workItemData.Activities;
        data.CheckList = workItemData.CheckList;
        data.Relations = workItemData.Relations;
        data.ID = id;
        data.CheckList?.forEach(c => {
            if (isNaN(c.ID)) {
                c.ID = 0;
            }
        }
        )
        /********************************* submit ************************/
        let result = null;
        setPendingSubmit(true);
        if (Number(id) > 0)
            result = await update(data);
        else
            result = await create(data);
        setPendingSubmit(false);
        /********************************* result ************************/
        if (result == null) {
            setErrorDialog(dispatch, "خطای ناشناخته", "ثبت/ویرایش اطلاعات");
        }
        else if (result.Message) {
            setErrorDialog(dispatch, result.Message, "ثبت/ویرایش اطلاعات");
        }
        else if (result.Data) {
            setErrorDialog(dispatch, "Success", "ثبت/ویرایش اطلاعات");

            history.replace(`/Projects/CreateEditWorkItem/${isProjectBool}/${result.Data.ID}`);
            if (result.Data.CheckList?.length > 0) {
                result.Data.TempCheckList = result.Data.CheckList.map(d => (
                    {
                        text: d.Title,
                        id: d.ID,
                        done: d.IsDone,
                        doneDate: d.PDoneDate,
                        doneByName: d.DoneByName,
                        doneComment: d.DoneComment
                    }));
            }
            result.Data.StartDate = convertToMoment(result.Data.StartDate);
            result.Data.DueDate = convertToMoment(result.Data.DueDate);
            result.Data.CompletedDate = convertToMoment(result.Data.CompletedDate);
            result.Data.AlarmDate = convertToMoment(result.Data.AlarmDate);
            /********************************* set data ************************/
            setWorkItemData(result.Data);
            setProgressPercent(result.Data.ProgressPercent);
            //setWorkItemData(result.Data);
            reset(result.Data);
        }
    }
    async function getData(id) {
        setPendingGet(true);
        if (!(Number(id) > 0)) {
            const result = await getNextNumber();
            if (result.Data) {
                setWorkItemData(prev => ({ ...prev, Number: result.Data }));
            }
            else {
                setErrorDialog(dispatch, result.Message, "دریافت شماره کار");
            }
            setPendingGet(false);
            return;
        }

        const result = await get(id);
        setPendingGet(false);
        if (result?.Error) {
            setErrorDialog(dispatchEvent, result.Error, "دریافت اطلاعات");
        }
        if (result?.Data) {
            if (result.Data.CheckList?.length > 0) {
                result.Data.TempCheckList = result.Data.CheckList.map(
                    d => ({
                        text: d.Title,
                        id: d.ID,
                        done: d.IsDone,
                        doneDate: d.PDoneDate,
                        doneByName: d.DoneByName,
                        doneComment: d.DoneComment
                    }));
            }
            result.Data.StartDate = convertToMoment(result.Data.StartDate);
            result.Data.DueDate = convertToMoment(result.Data.DueDate);
            result.Data.CompletedDate = convertToMoment(result.Data.CompletedDate);
            result.Data.AlarmDate = convertToMoment(result.Data.AlarmDate);

            setWorkItemData(result.Data);
            setProgressPercent(result.Data.ProgressPercent);
            reset(result.Data);
        }
    }
    async function getInfoes() {
        setBaseInfoes("PENDING");
        const result = await getWorkItemsBaseInfoes();
        if (result?.Data) {
            setBaseInfoes(result.Data);
        }
    }
    function showDocRefer() {
        setReferDocPop({
            show: true,
            documentHardCode: workItemTypes[workItemData.Type],
            documentGroupHardCode: "WorkItem",
            documentID: id
        });
    }
    function handleActivitiesChange(newActivities) {
        setWorkItemData(prev => ({ ...prev, Activities: newActivities }));
    }
    function handleLableSelect(label) {
        setWorkItemData(prev => {
            const wiLabel = { LabelId: Number(label.id), Label: label.text };
            let labels = [...prev.Labels ?? []];
            if (label.done) {
                const exists = labels.some(l => Number(l.LabelId) === Number(label.id));
                if (!exists) {
                    labels.push(wiLabel);
                }
            }
            else {
                labels = labels.filter(l => Number(l.LabelId) !== Number(label.id));
            }
            return { ...prev, Labels: labels };
        })
    }
    function showPopStatus(e) {
        setPopStatusData(prev => ({ e: prev?.e ? null : e, statusId: workItemData?.StatusID, workItemId: workItemData?.ID }));
    }
    function handleStatusChange(statusId) {
        setWorkItemData(prev => ({ ...prev, StatusID: statusId }));
        reset({ ...workItemData, StatusID: statusId });
    }
    function handleChangeRelations(newRelations) {
        setWorkItemData(prev => ({ ...prev, Relations: newRelations }));
    }
    async function handleToggleCheckList(item) {

        if (isNaN(item.id)) {
            return;
        }
        const result = await changeDoneStatus(item.id);
        if (result.Data) {
            let percent = 0;
            setWorkItemData(prev => {
                let checkList = [...prev.CheckList ?? []];

                checkList = checkList.map(
                    (ch) => ch.ID.toString() === item.id.toString() ?
                        {
                            ...ch,
                            IsDone: item.done,
                            ...result.Data
                        } : ch);
                if (checkList.length > 0) {
                    const doneLength = checkList.filter(c => c.IsDone.toString() == "true").length;
                    percent = doneLength / checkList.length * 100;
                }
                const tmpList = checkList.map(
                    d => ({
                        text: d.Title,
                        id: d.ID,
                        done: d.IsDone,
                        doneDate: d.PDoneDate,
                        doneByName: d.DoneByName,
                        doneComment: d.DoneComment
                    }));
                return { ...prev, CheckList: checkList, TempList: tmpList, ProgressPercent: percent };
            });
            setProgressPercent(percent);

        }
        else if (result.Message) {
            setErrorDialog(dispatch, result.Message, "ثبت/ویرایش چک لیست");
        }
        if (item.done && typeof (result.Data) === "object") {
            result.Data.doneByName = result.Data.DoneByName;
            result.Data.doneDate = result.Data.PDoneDate;
        }
        return result;

    }
    async function handleCommentCheckList(item) {

        if (isNaN(item.id)) {
            return;
        }
        const result = await setDoneComment(item);
        if (result.Data) {
            setWorkItemData(prev => {
                let checkList = [...prev.CheckList ?? []];

                checkList = checkList.map((ch) => ch.ID.toString() === item.id.toString() ? { ...ch, DoneComment: item.doneComment } : ch);
                const tmpList = checkList.map(
                    d => ({
                        text: d.Title,
                        id: d.ID,
                        done: d.IsDone,
                        doneDate: d.PDoneDate,
                        doneByName: d.DoneByName,
                        doneComment: d.DoneComment
                    }));
                return { ...prev, CheckList: checkList, TempCheckList: tmpList };
            });

        }
        else if (result.Message) {
            setErrorDialog(dispatch, result.Message, "ثبت/ویرایش چک لیست");
        }
        return result;

    }
    function handleUpdateCheckList(item) {
        setWorkItemData(prev => {
            let checkList = [...prev.CheckList ?? []];

            checkList = checkList.map((ch) => ch.ID.toString() === item.id.toString() ? { ...ch, Title: item.text } : ch);
            return { ...prev, CheckList: checkList };
        });
    }
    function handleRemoveCheckList(item) {
        let percent = 0;
        setWorkItemData(prev => {
            let checkList = [...prev.CheckList ?? []];
            checkList = checkList.filter((ch) => ch.ID.toString() !== item.id.toString());
            if (checkList.length > 0) {
                const doneLength = checkList.filter(c => c.IsDone.toString() == "true").length;
                percent = doneLength / checkList.length * 100;
            }
            return { ...prev, CheckList: checkList, ProgressPercent: percent };
        });
        setProgressPercent(percent);
    }
    async function handleAddCheckList(item) {
        const wiCheck = { Title: item.text, IsDone: false, SortOrder: 0, ID: item.id };
        let percent = 0;
        setWorkItemData(prev => {
            let checkList = [...prev.CheckList ?? []];
            checkList.push(wiCheck);
            checkList = checkList.map((ch) => ch.ID.toString() === item.id.toString() ? { ...ch, IsDone: item.done } : ch);
            if (checkList.length > 0) {
                const doneLength = checkList.filter(c => c.IsDone.toString() == "true").length;
                percent = doneLength / checkList.length * 100;
            }
            return { ...prev, CheckList: checkList, ProgressPercent: percent };
        });


        setProgressPercent(percent);

    }
    function handleLinkSelect(data) {
        setWorkItemData(prev => {
            const link = { ...data };
            let links = [...prev.Links ?? []];
            const exists = links.some(l => Number(l.EntityID) === Number(link.EntityID) && l.EntityType.toLowerCase() === link.EntityType.toLowerCase());
            if (!exists) {
                links.push(link);
            }
            return { ...prev, Links: links };
        })
    }
    function handleLinkRemove(data) {
        setWorkItemData(prev => {
            const link = { ...data };
            let links = [...prev.Links ?? []];
            links = links.filter(l => Number(l.EntityID) !== Number(link.EntityID) || l.EntityType.toLowerCase() !== link.EntityType.toLowerCase());
            return { ...prev, Links: links };
        })
    }
    function loadAttachList() {
        if (attachList === null) {
            getAttachmentList(id, "WorkItem", setAttachList);
        }
    }
    function delAttach(id) {
        dispatch(deleteAttachment(id, "WorkItem", () => getAttachmentList(id, "WorkItem", setAttachList)));
    }
    function attach() {
        dispatch(attachFile(inputAttach.current, id, "WorkItem", () => getAttachmentList(id, "WorkItem", setAttachList)));
    }
    const handleProjectSearch = async (qry) => {
        const result = await getProjectsForSelect(qry);
        if (Array.isArray(result?.Data)) {
            return result.Data.map(r => ({
                value: r.ID,
                label: r.Number
            }));
        }
        return [];
    }
    const handleProjectSelect = (opt) => {
        setWorkItemData(prev => ({
            ...prev,
            MainParentID: opt.value,
            MainParentNumber: opt.label
        }))
    }
    const showWorkItemLinkAttach = async (item) => {

        const type = item?.EntityGroupType?.toLowerCase() ?? "";
        if (type.includes("invoice")) {
            window.open(`/Sale/Invoice/${item.EntityType}/${item.EntityID}/${type.includes("formal")}`);
        }
        else if (type === "service") {
            window.open(`/Services/Service/${item.EntityID}/${item.EntityType}`)
        }
        else if (type === "ticket") {
            const id = await getCustomerIDFromTicketID(item.EntityID);
            if (id)
                window.open(`/CRM/AddEditCustomer/${id}`);
        }
        else if (type === "event") {
            const id = await getCustomerIDFromEventID(item.EntityID);
            if (id)
                window.open(`/CRM/AddEditCustomer/${id}`);
        }
        else if (type === "accdocument") {
            window.open(`/Accounting/AddEditDocument/${item.EntityID}`);
        }
        else if (type === "staff") {
            const isAgency = item.EntityType.toLowerCase() === "agency"
            window.open(`/Services/AddEditStaff/${isAgency}/${item.EntityID}`);
        }
        else if (type === "precustomer") {
            window.open(`/CRM/AddEditPreCustomer/${item.EntityID}`);
        }
        else if (type === "customer") {
            window.open(`/CRM/AddEditCustomer/${item.EntityID}`);
        }
        else if (type === "chequefunction") {
            setModalCheqFunctions({
                Show: true,
                FunctionID: item.EntityID,
                ChequeStatus: item.EntityType
            })
        }

    }

    //#endregion

    /************************************Attachments*******************************/
    const popAttachments = (
        (<Popover id="popover-basic" style={{ maxWidth: "500px", minWidth: "500px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle">
                <List size={18
                } />&nbsp;
                پیوست ها</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup>
                    <input type="file" className="form-control" ref={inputAttach} />
                    <Button className="btn-input-tiny" style={{ top: "1px", left: "1px" }} onClick={attach}><CloudUploadFill size={25} /></Button>
                </FormGroup>
                <Table responsive className="mt-2 fixedTable scrolledTable">
                    <thead>
                        <tr>
                            <th style={{ width: "25%" }}>تاریخ پیوست</th>
                            <th style={{ width: "50%" }}>نام فایل پیوست</th>
                            <th style={{ width: "25%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachList === "PENDING" &&
                            <tr>
                                <td colSpan={3} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={20} height={20} /></td>
                            </tr>}
                        {
                            Array.isArray(attachList) &&
                            attachList.map((atc, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "20%" }}>{atc.PAttachDate}</td>
                                    <td style={{ width: "65%", direction: "ltr" }}>{atc.AttachFileName}</td>
                                    <td style={{ width: "15%" }}>
                                        <Download size={18} color="blue" className="rowBtn" onClick={() => downloadFile(atc.ID, "WorkItem")} />&nbsp;&nbsp;
                                        <Trash size={18} color="red" className="rowBtn" onClick={() => delAttach(atc.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>))
    /*******************************************************************/
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مدیریت پروژه";

    }, [])
    useEffect(() => {
        getData(id);
        getInfoes();
    }, [id, isProjectBool])

    return (
        <div className="container-fluid mt-1">
            <ModalAddEditChequeFunctions popData={modalCheqFunctions} setPopData={setModalCheqFunctions} />
            <ModalReferDocument popData={popReferDoc} setPopData={setReferDocPop} />
            <ModalLabels
                setShow={setShowModalLabels}
                show={showModalLabels}
                onSelect={handleLableSelect}
                initLabels={workItemData.Labels}
            />
            {workItemData?.ID &&
                <PopWorkItemStatus statusList={baseInfoes?.StatusList} statusData={popStatusData} onChange={handleStatusChange} />
            }

            <Card>
                <Card.Header className="headerStyle" style={{ position: "relative" }}>
                    <FontAwesomeIcon icon={Number(id) > 0 ? faPenSquare : faPlusSquare} size="lg" />&nbsp;
                    ثبت و ارجاع وظیفه &nbsp;
                    <button className="tooltipBtn p-0 btn" data-tooltip="برچسب‌ها">
                        <FontAwesomeIcon icon={faTags} onClick={() => setShowModalLabels(true)} color="white" />
                    </button>
                    <div style={{
                        position: "absolute",
                        position: "absolute",
                        left: "10px",
                        top: 0,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        fontSize: "11px"
                    }}>
                        {Number(workItemData?.ID) > 0 &&
                            <div>
                                <label>شناسه کار: {workItemData.ID}</label>
                            </div>}
                        <div>
                            <label>شماره فرم: {workItemData.Number}</label>
                        </div>
                    </div>
                </Card.Header>
                {pendingGet ?
                    <div className="text-center p-3 bodyStyle">
                        <Loader type="BallTriangle" width={50} height={50} color="#bb1370" /></div> :
                    <Card.Body className="bodyStyle" style={{ textAlign: "right", position: "relative" }}>

                        <LabelList labels={workItemData?.Labels} />

                        <form onSubmit={handleSubmit(handleSubmitWorkItem)}>
                            <Row>
                                <Form.Control type="hidden" name="ID" ref={register({})} value={workItemData?.ID ?? ""} readOnly />
                                <Col md={2} className="form-group">
                                    <label>تاریخ ثبت:</label>
                                    <Form.Control name="CreationDate" value={workItemData?.PCreationDate} readOnly />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>نوع:</label>
                                    <select className="form-control" name="Type" ref={register({ required: true })}
                                        onChange={e => setWorkItemData(prev => ({ ...prev, Type: e.target.value }))}>
                                        <option value="">انتخاب کنید</option>
                                        <option value={workItemTypes.bug}>باگ</option>
                                        <option value={workItemTypes.changeRequest}>درخواست تغییر</option>
                                        <option value={workItemTypes.feature}>امکان جدید</option>
                                        <option value={workItemTypes.improvement}>بهینه‌سازی</option>
                                        <option value={workItemTypes.task}>وظیفه</option>
                                    </select>
                                    {errors.Type && <span className="errors">انتخاب نوع وظیفه ضروری است</span>}
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>وضعیت:</label>
                                    {
                                        baseInfoes == "PENDING" ?
                                            <div className="form-control">
                                                <Loader type="BallTriangle" width={21} height={21} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                                در حال بارگذاری فهرست...
                                            </div> :
                                            <select className="form-control" name="StatusID" ref={register({})} disabled>
                                                {Array.isArray(baseInfoes?.StatusList) &&
                                                    baseInfoes.StatusList.map((s, i) =>
                                                        <option key={i} value={s.Id}>{(s.StageName ? `[${s.StageName}]- ` : "") + s.Name}</option>)
                                                }
                                            </select>
                                    }
                                </Col>
                                {!isProjectBool &&
                                    <Col md={2} className="form-group">
                                        <label>پروژه مرتبط:</label>
                                        <SearchableSelect
                                            value={workItemData?.MainParentID ?? 0}
                                            defaultLabel={workItemData?.MainParentNumber ?? ""}
                                            name="MainParentID"
                                            control={control}
                                            placeholder="جستجوی شماره پروژه ..."
                                            loadOptions={handleProjectSearch}
                                            onChange={handleProjectSelect}
                                        />
                                    </Col>}

                                <Col md={2} className="form-group">
                                    <label>انتخاب بورد:</label>
                                    {
                                        baseInfoes == "PENDING" ?
                                            <div className="form-control">
                                                <Loader type="BallTriangle" width={21} height={21} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                                در حال بارگذاری فهرست...
                                            </div> :
                                            <select className="form-control" name="BoardID" ref={register({})}>
                                                <option value="">انتخاب کنید</option>
                                                {Array.isArray(baseInfoes?.BoardList) &&
                                                    baseInfoes.BoardList.map((s, i) =>
                                                        <option key={i} value={s.ID}>{s.InfoName}</option>)
                                                }
                                            </select>
                                    }
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>دسته‌بندی:</label>{/* &zwnj; */}
                                    {
                                        baseInfoes == "PENDING" ?
                                            <div className="form-control">
                                                <Loader type="BallTriangle" width={21} height={21} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                                در حال بارگذاری فهرست...
                                            </div> :
                                            <select className="form-control" name="CategoryID" ref={register({})}>
                                                <option value="">انتخاب کنید</option>
                                                {Array.isArray(baseInfoes?.CategoryList) &&
                                                    baseInfoes.CategoryList.map((s, i) =>
                                                        <option key={i} value={s.ID}>{s.InfoName}</option>)
                                                }
                                            </select>
                                    }

                                    {/* {errors?.CategoryID &&
                                <span className="errors">دسته‌بندی انتخاب نشده است</span>
                                } */}
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>اهمیت:</label>
                                    <select className="form-control" name="Severity" ref={register({})}>
                                        <option value={workItemSeverity.critical}>فوری</option>
                                        <option value={workItemSeverity.major}>زیاد</option>
                                        <option value={workItemSeverity.medium}>متوسط</option>
                                        <option value={workItemSeverity.minor}>کم</option>
                                        <option value={workItemSeverity.trivial}>بسیار پایین</option>
                                    </select>
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>اولویت:</label>
                                    <select className="form-control" name="Priority" ref={register({})}>
                                        <option value={4}>بسیار بالا</option>
                                        <option value={3}>بالا</option>
                                        <option value={2}>نرمال</option>
                                        <option value={1}>پایین</option>
                                    </select>
                                </Col>
                                <Col className="form-group border" >
                                    <label style={{ color: "#36369c", borderBottom: "1px solid #b3b3f1" }}>فرم‌های پیوست:</label>
                                    <WorkItemLinks links={workItemData.Links}
                                        className="mt-1"
                                        onAdd={handleLinkSelect}
                                        onRemove={handleLinkRemove}
                                        onClick={showWorkItemLinkAttach} />
                                </Col>
                            </Row>
                            <Row className="rowBorder mt-3">

                                <div className="rowTitle">موضوع(هدف وظیفه)</div>
                                <FormGroup>
                                    <Form.Control as="textarea" cols={2} name="Title" ref={register({ required: true })} />
                                    {errors?.Title && <span className="errors">موضوع الزامی است.</span>}
                                </FormGroup>
                            </Row>
                            <Checklist
                                title="چک لیست"
                                checkable={Number(workItemData?.ID) > 0}
                                classNames="custom-checklist-container1"
                                initialItems={workItemData?.TempCheckList}
                                hasDoneComment={true}
                                onAdd={handleAddCheckList}
                                onUpdate={handleUpdateCheckList}
                                onRemove={handleRemoveCheckList}
                                onToggle={handleToggleCheckList}
                                onSetComment={handleCommentCheckList}
                            />

                            <WorkItemControl
                                workItemData={workItemData}
                                setWorkItemData={setWorkItemData}
                                register={register}
                                control={control} />
                            <Row className="rowBorder mt-3">
                                <div className="rowTitle">فهرست کارهای مرتبط</div>
                                <WorkItemRelations
                                    type={workItemData.Type}
                                    relations={workItemData?.Relations}
                                    onChange={handleChangeRelations}
                                    control={control} />
                            </Row>
                            {Number(workItemData?.ID) > 0 &&
                                <Row className="rowBorder mt-3">
                                    <div className="rowTitle">فعالیت‌ها</div>
                                    <ActivityList
                                        workItemId={workItemData?.ID ?? 0}
                                        activities={workItemData?.Activities ?? []}
                                        onChange={handleActivitiesChange}
                                        control={control} />
                                </Row>
                            }
                            {Number(workItemData?.ID) > 0 &&
                                <WorkItemRefer workItem={workItemData} doRefer={true} />}
                            <div style={{ position: "sticky", bottom: "5px" }}>
                                <ProgressBar
                                    value={progressPercent}
                                    onChange={setProgressPercent}
                                    alwaysShowTooltip={true}
                                />
                            </div>
                            <div className="d-flex gap-1">
                                <Button variant="success" type="submit" disabled={pendingSubmit} className="mt-1 group-Btn-large">
                                    {pendingSubmit ?
                                        <Loader type="TailSpin" color="white" width={16} height={16} style={{ display: "inline-block" }} /> :
                                        <CheckLg size={21} />
                                    }&nbsp;
                                    ثبت تغییرات
                                </Button>
                                {
                                    Number(workItemData?.ID) > 0 &&
                                    <>
                                        <Button variant="secondary" className="mt-1 group-Btn-large" disabled={pendingSubmit} onClick={showPopStatus}>
                                            <Toggles2 size={18} />&nbsp; تغییر وضعیت
                                        </Button>
                                        <OverlayTrigger trigger="click" placement="top" overlay={popAttachments} rootClose>
                                            <Button variant="light" className="mt-1 group-Btn-large btn-violet" onClick={loadAttachList}><Link45deg size={19} />&nbsp;پیوست ها</Button>
                                        </OverlayTrigger>
                                    </>
                                }
                            </div>
                        </form>
                        {!isMobile && workItemData?.ID &&
                            <Col md={2} style={{ fontSize: "11px", color: "blue", position: "absolute", left: 5, bottom: 3, maxWidth: "fit-content" }}>
                                {
                                    workItemData.PCreationDate?.length > 0 &&
                                    <div style={{ float: "left", textAlign: "right", minWidth: "150px" }}>
                                        &nbsp;<Calendar2DateFill size={14} color="#2894b1" /><label>&nbsp;تاریخ ثبت: {workItemData.PCreationDate}</label>
                                    </div>
                                }
                                {workItemData.CreateByName?.length > 0 &&
                                    <div style={{ float: "left", textAlign: "right", minWidth: "150px" }}>
                                        <PersonPlusFill size={17} color="#ff5e00" /><label>&nbsp;ثبت کننده: {workItemData.CreateByName}</label>
                                    </div>
                                }
                            </Col>
                        }


                    </Card.Body>
                }
            </Card>
        </div >
    )
}